module.exports = __webpack_public_path__ + "img/3.055360f2.png";